import styled, { css } from 'styled-components';
import { Container, IconCard, Paragraph } from '@swordhealth/ui-corporate';

export const StyledContainer = styled(Container)`
  display: flex;
  gap: 64px;

  @media (max-width: ${(props) => props.theme.breakpoints.min_md}px) {
    gap: 40px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 64px;
  }
`;

export const ContactCard = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  background: ${({ $colored, theme }) =>
    $colored ? theme.colors.neutral[200] : theme.colors.white};
  border-radius: ${(props) => props.theme.borderRadius.default.lg};
  flex: 1;

  @media (max-width: ${(props) => props.theme.breakpoints.min_md}px) {
    width: 324px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px 28px 28px 28px;

  h2 {
    text-wrap: unset;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.min_md}px) {
    padding: 16px 20px 20px 20px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 176px;
  height: 304px;
  border-radius: ${(props) => props.theme.borderRadius.default.lg};
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breakpoints.min_md}px) {
    max-height: 183px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    max-height: 175.5px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;

  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.grey.dark};
    cursor: pointer;

    &:hover {
      color: inherit;
    }
  }

  ${(props) =>
    props.hasDivider &&
    css`
      padding-top: 24px;
      border-top: 1px solid ${(props) => props.theme.colors.grey[300]};
    `};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 12px;

  @media (min-width: ${(props) => props.theme.breakpoints.min_sm}px) {
    a {
      width: 160px;
    }
  }
`;

export const StyledParagraph = styled(Paragraph)`
  color: ${(props) => props.theme.colors.grey[600]};
`;

export const BulletPanelList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  flex: 1;

  h2 {
    text-wrap: unset;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.min_md}px) {
    gap: 24px;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const StyledBullet = styled(IconCard)`
  column-gap: var(--ui-spacings-sm);
  row-gap: 0;

  p {
    font-weight: 600;
  }

  span {
    width: 24px;
    height: 28px;
  }
`;
